import { useEffect } from 'react';

import EligibilitySetupBody from 'components/practice/Settings/components/HealthcareProgram/components/EligibilitySetupTab/components/EligibilitySetupBody';
import { useEligibilitySetupDraft } from 'components/practice/Settings/components/HealthcareProgram/components/EligibilitySetupTab/lib/useEligibilitySetupDraft';
import Skeleton from 'components/shared/Skeleton/Skeleton';
import Typography from 'components/shared/Typography/Typography';

const OnboardingEligibilitySetup = ({
  addFooterActions,
  mutateOrchestratorData,
  orchestratorLoading,
  orchestratorData
}) => {
  const {
    data,
    isLoading,
    isError,
    draft,
    isDirty,
    isSaving,
    handleThresholdChange,
    handleStepsChange,
    saveAsync
  } = useEligibilitySetupDraft({
    practiceId: orchestratorData?.practiceId,
    enabled: !!orchestratorData?.practiceId
  });

  useEffect(() => {
    addFooterActions([
      {
        text: 'Continue',
        onClick: async () => {
          if (isError) return;
          if (isDirty) {
            try {
              const ok = await saveAsync();
              if (!ok) return;
            } catch {
              return;
            }
          }
          mutateOrchestratorData({});
        },
        isDisabled: orchestratorLoading || isSaving || isError
      }
    ]);
  }, [
    addFooterActions,
    isDirty,
    isError,
    isSaving,
    orchestratorLoading,
    saveAsync,
    mutateOrchestratorData
  ]);

  if (isLoading && !data) {
    return (
      <div className="w-full p-6">
        <Skeleton count={4} height={40} containerClassName="w-full" />
      </div>
    );
  }

  if (isError) {
    return (
      <div className="w-full p-6">
        <Typography size="small" color="danger-600">
          Failed to load eligibility setup settings.
        </Typography>
      </div>
    );
  }

  return (
    <EligibilitySetupBody
      draft={draft}
      onThresholdChange={handleThresholdChange}
      onStepsChange={handleStepsChange}
    />
  );
};

export default OnboardingEligibilitySetup;
